import { render } from "./TheLoading.vue?vue&type=template&id=10a98215&ts=true"
import script from "./TheLoading.vue?vue&type=script&lang=ts"
export * from "./TheLoading.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__